import _ from "lodash";
import produce from "immer";
import axios from "axios";
import strings from "../../../res/strings";
import { setAppProcessing, setAppSuccess, setAppError } from "../../common";

export const RETRIEVE_SUB_ACCOUNTS = "subAccounts/RETRIEVE_SUB_ACCOUNTS";
export const CREATE_SUB_ACCOUNT = "subAccounts/CREATE_SUB_ACCOUNT";
export const UPDATE_SUB_ACCOUNT = "subAccounts/UPDATE_SUB_ACCOUNT";
export const DELETE_SUB_ACCOUNT = "subAccounts/DELETE_SUB_ACCOUNT";
export const REFRESH_SUB_ACCOUNT_CREDENTIALS =
  "subAccount/REFRESH_SUB_ACCOUNT_CREDENTIALS";

const RETRIEVE_SUB_ACCOUNTS_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const CREATE_SUB_ACCOUNT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const UPDATE_SUB_ACCOUNT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const DELETE_SUB_ACCOUNT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const initialState = {
  subAccounts: [],
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case RETRIEVE_SUB_ACCOUNTS: {
        draft.subAccounts = action.subAccounts;
        break;
      }

      case CREATE_SUB_ACCOUNT: {
        break;
      }

      case UPDATE_SUB_ACCOUNT: {
        break;
      }

      case DELETE_SUB_ACCOUNT: {
        break;
      }

      case REFRESH_SUB_ACCOUNT_CREDENTIALS: {
        break;
      }

      default: {
        break;
      }
    }
  });

export const retrieveSubAccounts = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_account.retrieveSubAccounts",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_ACCOUNT_RETRIEVE_SUB_ACCOUNTS,
        values
      )
      .then((response) => {
        const subAccounts = _.get(response, "data.sub_accounts", []);
        dispatch({ type: RETRIEVE_SUB_ACCOUNTS, subAccounts });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "lib_account.retrieveSubAccounts",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        const error = RETRIEVE_SUB_ACCOUNTS_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context: "lib_account.retrieveSubAccounts",
                },
            history
          )
        );
      });
  };
};

export const createSubAccount = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_account.createSubAccount",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_ACCOUNT_CREATE_SUB_ACCOUNT,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_SUB_ACCOUNT });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "lib_account.createSubAccount",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        const error = CREATE_SUB_ACCOUNT_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_account.createSubAccount",
                  ...error,
                },
            history
          )
        );
      });
  };
};

export const updateSubAccount = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_account.updateSubAccount",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_ACCOUNT_UPDATE_SUB_ACCOUNT,
        values
      )
      .then((response) => {
        dispatch({ type: UPDATE_SUB_ACCOUNT });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "lib_account.updateSubAccount",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        const error = UPDATE_SUB_ACCOUNT_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_account.updateSubAccount",
                },
            history
          )
        );
      });
  };
};

export const deleteSubAccount = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_account.deleteSubAccount",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_ACCOUNT_DELETE_SUB_ACCOUNT,
        values
      )
      .then((response) => {
        dispatch({ type: DELETE_SUB_ACCOUNT });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "lib_account.deleteSubAccount",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        const error = DELETE_SUB_ACCOUNT_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_account.deleteSubAccount",
                  ...error,
                },
            history
          )
        );
      });
  };
};

export const refreshSubAccountCredentials = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_account.refreshSubAccountCredentials",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_ACCOUNT_REFRESH_SUB_ACCOUNT_CREDENTIALS,
        values
      )
      .then((response) => {
        dispatch({ type: REFRESH_SUB_ACCOUNT_CREDENTIALS });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "lib_account.refreshSubAccountCredentials",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        const error = REFRESH_SUB_ACCOUNT_CREDENTIALS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_account.refreshSubAccountCredentials",
                  ...error,
                },
            history
          )
        );
      });
  };
};
